import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { LoaderOverlay } from '@shared/ui/loader/loader-overlay/loader-overlay';
import { APP_VERSION } from '@env/version';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoaderOverlay],
  template: `
    <router-outlet />
    <app-loader-overlay />
    <span class="app-version">{{ appVersion }}</span>
  `,
  styleUrl: './app.scss',
})
export class App {
  protected readonly appVersion = APP_VERSION;

  constructor() {
    // The app uses the variable Material Symbols font (see index.html).
    inject(MatIconRegistry).setDefaultFontSetClass('material-symbols-outlined');
  }
}
